function initTransparencySection(root) {
  if (!root || root.dataset.transparencyInit) return;
  root.dataset.transparencyInit = 'true';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var duration = 1400;

  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function animateBar(row) {
    var fill = row.querySelector('[data-fill-target]');
    var percent = row.querySelector('[data-percent-target]');
    if (!fill || !percent) return;

    var target = parseFloat(fill.getAttribute('data-fill-target')) || 0;

    if (prefersReducedMotion) {
      fill.style.width = target + '%';
      percent.textContent = Math.round(target) + '%';
      return;
    }

    requestAnimationFrame(function () {
      fill.style.width = target + '%';
    });

    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = easeOutExpo(progress);
      percent.textContent = Math.round(eased * target) + '%';
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }

  function reveal(el) {
    el.classList.add('is-visible');
    if (el.classList.contains('transparency__row')) {
      animateBar(el);
    }
  }

  var fadeTargets = root.querySelectorAll('.fade-in-up');
  if (!fadeTargets.length) return;

  if (!('IntersectionObserver' in window)) {
    fadeTargets.forEach(reveal);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3, rootMargin: '0px 0px -10% 0px' }
  );

  fadeTargets.forEach(function (el) {
    observer.observe(el);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.section-transparency').forEach(initTransparencySection);
});

document.addEventListener('shopify:section:load', function (event) {
  var root = event.target.querySelector('.section-transparency');
  if (root) initTransparencySection(root);
});